<div class="attachment-dialog">
    <div *ngIf="!data.showPdfView">
        <div class="head">
            <h2>
                Attach invoice to transaction
            </h2>
            <img src="../../../assets/images/cross_icon_grey.svg" alt=" " tabindex="0" mat-dialog-close="0" width="24px"
                height="24px">
        </div>
        <div class="body">
            <ng-container *ngIf="!isLoading; else searchLoader">
                <mat-form-field class="transactions-search-field m-search-field">
                    <img src="../../assets/images/search.svg" alt="search" matPrefix />
                    <input class="search-input" matInput placeholder="Search by number" autocomplete="off" [(ngModel)]="search"
                        (keyup)="searchHandler()" (keyup)="handleBackspaceClear($event)" autocomplete="off">
                    <div matIconSuffix class="clear-date" *ngIf="search">
                        <button class="btn-clear no-button" (click)="clearFilter()">
                            <img src="../../../assets/images/cross_icon_grey.svg" height="19px" width="19px" alt=" " />
                        </button>
                    </div>
                </mat-form-field>
            </ng-container>
            <div class="attachment-table-scroll" (scroll)="onTableScroll($event)">
                <table [hidden]="isTableLoading" id="view-table" class="attachment-table" mat-table [dataSource]="dataSource"
                    matSort matSortDisableClear (matSortChange)="sortChange()" matSortActive="issueDate" matSortDirection="desc">

                    <ng-container matColumnDef="invoiceNumber">
                        <th mat-header-cell *matHeaderCellDef>
                            Number
                        </th>
                        <td mat-cell *matCellDef="let element; let i = index">
                            <div class="multi-checkbox">
                                <mat-checkbox [disableRipple]="true" class="mat-green-checkbox-g" [value]="element.id" [checked]="invoiceIdExists(element.id)" (change)="selectionChangeValue($event, element)"></mat-checkbox>
                                <span class="radio-label">{{ element.invoiceNumber || '-' }}</span>
                            </div>
                        </td>
                    </ng-container>
                    <ng-container matColumnDef="counterpartyName">
                        <th mat-header-cell *matHeaderCellDef>
                            Counterparty
                        </th>
                        <td mat-cell *matCellDef="let element">
                            {{ element.counterparty?.name || '-' }}
                        </td>
                    </ng-container>

                    <ng-container matColumnDef="issueDate">
                        <th mat-header-cell *matHeaderCellDef mat-sort-header="issueDate">
                            Date
                        </th>
                        <td mat-cell *matCellDef="let element">
                            {{ (element.issueDate ? (element.issueDate | date: 'dd MMM, yyyy'): '-') }}
                        </td>
                    </ng-container>

                    <ng-container matColumnDef="totalAmount">
                        <th mat-header-cell *matHeaderCellDef>
                            Amount
                        </th>
                        <td mat-cell *matCellDef="let element">
                            {{((element.totalAmount)| number : '1.2' | convertWithDecimal:selectedVehicle:false:false:'') + ' €'}}
                        </td>
                    </ng-container>

                    <ng-container matColumnDef="isTransactionLinked">
                        <th mat-header-cell *matHeaderCellDef>
                            Linked
                        </th>
                        <td mat-cell *matCellDef="let element">
                            <ng-container *ngIf="isInvoiceLinked(element); else noLink">
                                <img src="../../../../assets/images/check_icon.svg" alt=" " width="20px"
                                    height="20px">
                            </ng-container>
                            <ng-template #noLink>
                                <img src="../../../../assets/images/info_icon_orange.svg" alt=" " width="20px"
                                    height="20px">
                            </ng-template>
                        </td>
                    </ng-container>

                    <ng-container matColumnDef="actions">
                        <th mat-header-cell *matHeaderCellDef>
                            Actions
                        </th>
                        <td mat-cell *matCellDef="let element">
                            <button class="no-button" [matMenuTriggerFor]="contactMenu">
                                <img src="../../../../assets/images/more_icon.svg" alt="View" width="24px"
                                    height="24px">
                                <mat-menu class="m-mat-menu" #contactMenu="matMenu" xPosition="before"
                                    counterpart-detail-action-position>
                                    <div mat-menu-item (click)="viewPdf(element)">
                                        <img src="../../../assets/images/eye_icon.svg" alt=" " width="20px"
                                            height="20px">
                                        <span class="menu-text">View</span>   
                                    </div>
                                </mat-menu>
                            </button>
                        </td>
                    </ng-container>
                    <tr mat-header-row *matHeaderRowDef="displayedColumns; sticky: true"></tr>
                    <tr mat-row *matRowDef="let row; columns: displayedColumns;" [ngClass]="{ 'selected-invoice-row': invoiceIdExists(row.id) }"></tr>

                    <tr class="mat-row" *matNoDataRow>
                        <td class="mat-cell no-row no-row-transaction no-row-invoice" colspan="6" style="padding:1rem;">
                            <div class="no-transaction-found-container">
                                <img src="../../../../assets/images/invoice_empty_icon.svg" alt="no-invoice">
                                <div class="text-section">
                                    <div class="heading">No Invoices found</div>
                                    <div class="supporting-text">It looks like there are no invoices found in the linked
                                        accounts. Please check again after sometime.</div>
                                </div>
                            </div>
                        </td>
                    </tr>
                </table>
                <table id="loader-table" *ngIf="isTableLoading" class="attachment-table" mat-table [dataSource]="[1, 2, 3, 4, 5, 6]" matSort  #loaderTable="matSort">
                    <ng-container matColumnDef="invoiceNumber">
                        <th mat-header-cell *matHeaderCellDef> Number </th>
                        <td mat-cell *matCellDef="let element">
                            <div class="align-loader-name">
                                <ngx-skeleton-loader count="1" appearance="line" [theme]="{
                                    width: '20px',
                                    height: '20px',
                                    marginBottom: 0,
                                    marginRight: '12px',
                                    borderRadius: '50%',
                                    verticalAlign: 'middle'
                                  }">
                                </ngx-skeleton-loader>
                            </div>
                            <ngx-skeleton-loader count="1" appearance="line" [theme]="{
                                    width: '150px',
                                    height: '24px',
                                    marginBottom: 0,
                                    verticalAlign: 'middle'
                              }">
                            </ngx-skeleton-loader>
                        </td>
                    </ng-container>
 
                    <ng-container matColumnDef="counterpartyName">
                        <th mat-header-cell *matHeaderCellDef> Counterparty </th>
                        <td mat-cell *matCellDef="let element">
                            <ngx-skeleton-loader count="1" appearance="line" [theme]="{
                                                        width: '250px',
                                                        height: '24px',
                                                        marginBottom: 0
                                                      }">
                            </ngx-skeleton-loader>
                        </td>
                    </ng-container>
 
                    <ng-container matColumnDef="issueDate">
                        <th mat-header-cell *matHeaderCellDef> Date </th>
                        <td mat-cell *matCellDef="let element">
                            <ngx-skeleton-loader count="1" appearance="line" [theme]="{
                                                        width: '300px',
                                                        height: '24px',
                                                        marginBottom: 0
                                                      }">
                            </ngx-skeleton-loader>
                        </td>
                    </ng-container>
 
                    <ng-container matColumnDef="totalAmount">
                        <th mat-header-cell *matHeaderCellDef> Amount </th>
                        <td mat-cell *matCellDef="let element">
                            <ngx-skeleton-loader count="1" appearance="line" [theme]="{
                                                        width: '100px',
                                                        height: '24px',
                                                        marginBottom: 0
                                                      }">
                            </ngx-skeleton-loader>
                        </td>
                    </ng-container>
 
                    <ng-container matColumnDef="isTransactionLinked">
                        <th mat-header-cell *matHeaderCellDef> Linked </th>
                        <td mat-cell *matCellDef="let element">
                            <ngx-skeleton-loader count="1" appearance="line" [theme]="{
                                                        width: '20px',
                                                        height: '20px',
                                                        marginBottom: 0,
                                                        borderRadius: '50%'
                                                      }">
                            </ngx-skeleton-loader>
                        </td>
                    </ng-container>
 
                    <ng-container matColumnDef="actions">
                        <th mat-header-cell *matHeaderCellDef> Actions</th>
                        <td mat-cell *matCellDef="let element">
                            <ngx-skeleton-loader count="1" appearance="line" [theme]="{
                                                        width: '24px',
                                                        height: '24px',
                                                        marginBottom: 0
                                                      }">
                            </ngx-skeleton-loader>
                        </td>
                    </ng-container>
 
                    <ng-container matColumnDef="attachment">
                        <th mat-header-cell *matHeaderCellDef> Attachment </th>
                        <td mat-cell *matCellDef="let element">
                            <ngx-skeleton-loader count="1" appearance="line" [theme]="{
                                                        width: '20px',
                                                        height: '20px',
                                                        marginBottom: 0
                                                      }">
                            </ngx-skeleton-loader>
                        </td>
                    </ng-container>
 
                    <ng-container matColumnDef="details">
                        <th mat-header-cell *matHeaderCellDef> </th>
                        <td mat-cell *matCellDef="let element"> </td>
                    </ng-container>
 
                    <tr mat-header-row *matHeaderRowDef="displayedColumns; sticky: true"></tr>
                    <tr mat-row *matRowDef="let row; columns: displayedColumns;"></tr>
                </table>
            </div>
            <ng-container *ngIf="scrollTableLoading">
                <div class="comment-loader">
                    <img src="../../../../assets/images/lazy_loading_spinner.svg" alt="spiner-loader"/>
                </div>
            </ng-container>
        </div>
        <div class="footer">
            <ng-container *ngIf="!isLoading else buttonLoader">
                <button class="cancel" mat-dialog-close="0">
                    Cancel
                </button>
            </ng-container>
            <ng-container *ngIf="!isLoading else buttonLoader">
                <button class="attach"  [mat-dialog-close]="{status: 1, details: true, ids: selectedInvoiceIds}" [ngClass]="{ 'disabled-btn': selectedInvoiceIds.length <= 0}" (click)="linkInvoice()">
                    Attach
                </button>
            </ng-container>
        </div>
    </div>
    <ng-container *ngIf="data.showPdfView">
        <ng-container *ngIf="!data.detailsView; else detailsViewBlock">
          <ng-container *ngTemplateOutlet="pdfViewBlock; context: {
            invoiceNumber: pdfData.invoiceNumber,
            documentUrl: pdfData.documentUrl
          }"></ng-container>
        </ng-container>
      
        <ng-template #detailsViewBlock>
          <ng-container *ngTemplateOutlet="pdfViewBlock; context: {
            invoiceNumber: data.viewPdfdata.invoiceNumber,
            documentUrl: data.viewPdfdata.documentUrl
          }"></ng-container>
        </ng-template>
      
        <ng-template #pdfViewBlock let-invoiceNumber="invoiceNumber" let-documentUrl="documentUrl">
          <div class="head">
            <div class="pdf-head">
              <button *ngIf="!data.detailsView" class="no-button attachment-back" (click)="backButton()" height="24px">
                <img src="../../../assets/images/back_icon.svg" alt="Back" tabindex="0" width="24px" height="24px" />
              </button>
              <h2>{{ invoiceNumber }}</h2>
            </div>
            <img src="../../../assets/images/cross_icon_grey.svg" alt="Close" tabindex="0" mat-dialog-close="0" width="24px" height="24px" />
          </div>
      
          <div class="body pdf-body">
            <app-pdf-apryse
              [filePath]="getDocumentUrl(documentUrl)"
              [fileName]="invoiceNumber"
              [isShowAnnotation]="false">
            </app-pdf-apryse>
          </div>
        </ng-template>
      </ng-container>      
</div>

<ng-template #searchLoader>
    <div class="m-search-field">
        <ngx-skeleton-loader count="1" appearance="line" [theme]="{
            width: '400px',
            height: '38px',
            marginBottom: 0
        }"></ngx-skeleton-loader>
    </div>
</ng-template>

<ng-template #buttonLoader>
    <ngx-skeleton-loader count="1" appearance="line" [theme]="{
        width: '145px',
        height: '44px',
        marginBottom: 0
    }"></ngx-skeleton-loader>
</ng-template>